export const sortShipmentsBySeq = (shipments) => {
  shipments.sort((a, b) => (Number(a.seq) < Number(b.seq) ? -1 : 1));
  return shipments;
};
